(function () {
  'use strict';

  // seeded noise so erosion looks the same on every load
  function rng(seed) {
    return function () {
      seed = (Math.imul(seed ^ (seed >>> 15), seed | 1) + 0x6d2b79f5) | 0;
      return (seed >>> 0) / 4294967296;
    };
  }

  function token(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--' + name).trim();
    return v || fallback;
  }

  // grain tile for the dark panels
  (function grain() {
    var c = document.createElement('canvas');
    c.width = c.height = 120;
    var g = c.getContext('2d');
    var r = rng(7);
    var im = g.createImageData(120, 120);
    for (var i = 0; i < im.data.length; i += 4) {
      var v = r() < 0.5 ? 0 : 255;
      im.data[i] = im.data[i + 1] = im.data[i + 2] = v;
      im.data[i + 3] = r() < 0.35 ? 255 : 0;
    }
    g.putImageData(im, 0, 0);
    document.documentElement.style.setProperty('--grain', 'url(' + c.toDataURL() + ')');
  })();

  // pixel-eroded type: draw the words, then eat their edges with blocky noise
  function erode(canvas) {
    var W = canvas.width, H = canvas.height, ctx = canvas.getContext('2d');
    var d = canvas.dataset;
    var lines = (d.lines || '').split('|').filter(Boolean);
    if (!lines.length) return;
    var cell = +d.cell || 6, bite = +d.bite || 0.9, dust = +d.dust || 0.004, seed = +d.seed || 11;
    var size = +d.size || 400, weight = d.weight || '600';
    var ink = d.ink === 'bone' ? token('bone', '#f1f0ec') : token('soot', '#0f0f10');

    var off = document.createElement('canvas');
    off.width = W; off.height = H;
    var o = off.getContext('2d');
    o.fillStyle = '#000';
    o.textAlign = 'center';
    o.textBaseline = 'alphabetic';
    o.font = weight + ' ' + size + 'px "Playfair Mark", "Playfair", "Bodoni Moda", serif';
    // shrink to fit the canvas width
    var widest = Math.max.apply(null, lines.map(function (l) { return o.measureText(l).width; }));
    if (widest > W * 0.94) {
      size = Math.floor(size * (W * 0.94) / widest);
      o.font = weight + ' ' + size + 'px "Playfair Mark", "Playfair", "Bodoni Moda", serif';
    }
    // centre each line in its band using the real cap height
    var cap = o.measureText('H').actualBoundingBoxAscent || size * 0.7;
    var step = H / lines.length;
    lines.forEach(function (l, i) { o.fillText(l, W / 2, step * i + step / 2 + cap / 2); });

    var src = o.getImageData(0, 0, W, H).data;
    var r = rng(seed);
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = ink;
    var half = cell >> 1;
    for (var y = 0; y < H; y += cell) {
      for (var x = 0; x < W; x += cell) {
        var cy = Math.min(H - 1, y + half), cx = Math.min(W - 1, x + half);
        var a = src[(cy * W + cx) * 4 + 3] / 255;
        var n = 0;
        [[-3, 0], [3, 0], [0, -3], [0, 3]].forEach(function (p) {
          var xx = cx + p[0] * cell, yy = cy + p[1] * cell;
          if (xx >= 0 && yy >= 0 && xx < W && yy < H) n += src[(yy * W + xx) * 4 + 3] / 255;
        });
        var edge = 1 - n / 4;
        if (a > 0.5 && r() > edge * bite) ctx.fillRect(x, y, cell, cell);
        else if (a <= 0.5 && r() < dust) ctx.fillRect(x, y, cell, cell);
      }
    }
  }

  function drawAll() {
    document.querySelectorAll('canvas.zt-erode').forEach(erode);
  }
  if (document.fonts && document.fonts.load) {
    Promise.all([
      document.fonts.load('600 200px "Playfair Mark"'),
      document.fonts.load('800 200px "Playfair Mark"')
    ]).catch(function () {}).then(drawAll);
  } else {
    drawAll();
  }
  // redraw when the theme editor reloads a section
  document.addEventListener('shopify:section:load', drawAll);

  // add to bag without leaving the page; the form still works without script
  var S = (window.ZT && window.ZT.strings) || {};
  var R = (window.ZT && window.ZT.routes) || { cart: '/cart', cartAdd: '/cart/add' };

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('zt-add')) return;
    var status = form.querySelector('.status');
    var idInput = form.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]');
    if (!idInput) {
      e.preventDefault();
      if (status) status.textContent = S.pickSize || 'Pick a size first.';
      return;
    }
    if (!window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(R.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) { if (!res.ok) throw new Error('add failed'); return res.json(); })
      .then(function () { return fetch(R.cart + '.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (status) {
          status.textContent = (S.added || 'Added.') + ' ';
          var a = document.createElement('a');
          a.href = R.cart;
          a.textContent = S.viewBag || 'View bag';
          status.appendChild(a);
        }
      })
      .catch(function () { if (status) status.textContent = S.error || 'Something went wrong.'; })
      .then(function () { if (btn) btn.disabled = false; });
  });

  document.addEventListener('change', function (e) {
    if (e.target.name === 'id') {
      var s = e.target.form && e.target.form.querySelector('.status');
      if (s) s.textContent = '';
    }
  });
})();
